<div [ngClass]="{'hide-grid':conflictPaginationInfo && conflictPaginationInfo.totalRecords == 0 }">
  <div class="manageExamErrorSec">
    <p>{{ errorMsg }}</p>
  </div>
  <!-- grid code -->


  <div class="button-row conflict-row">
    <h6>Conflicts</h6>
    <button style="float:right" md-raised-button class="glbAdminBtnCls1" (click)="onPrint()">
      <i class="material-icons">&#xE8AD;</i>PRINT</button>
  </div>
  <div class="cusPaginationContainer example-container">
    <md-table class="mngLocGridSec" #table [dataSource]="dataSource" mdSort>

      <md-header-row *mdHeaderRowDef="displayedColumns"></md-header-row>
      <md-row *mdRowDef="let row; columns: displayedColumns;"></md-row>

      <!-- examStartDateTime Column -->
      <ng-container mdColumnDef="examStartDateTime">
        <md-header-cell *mdHeaderCellDef md-sort-header>DATE & TIME</md-header-cell>
        <md-cell *mdCellDef="let element">{{ (element.examStartDateTime | dateTimeFormat:'') + ((element.timezone && element.timezone!=null)?(' ' + element.timezone):'') }}</md-cell>
        <!-- + ' ' + element.timezone -->
      </ng-container>

      <!-- candidateName Column -->
      <ng-container mdColumnDef="candidateName">
        <md-header-cell *mdHeaderCellDef md-sort-header>CANDIDATE NAME</md-header-cell>
        <md-cell *mdCellDef="let element"> {{element.candidateName}} </md-cell>
      </ng-container>

      <!-- candidatePhoneNumber Column -->
      <ng-container mdColumnDef="candidateContactNumber">
        <md-header-cell *mdHeaderCellDef md-sort-header>CANDIDATE PHONE #</md-header-cell>
        <md-cell *mdCellDef="let element"> {{element.candidateContactNumber}} </md-cell>
      </ng-container>

      <!-- candidateEmail Column -->
      <ng-container mdColumnDef="candidateEmail">
        <md-header-cell *mdHeaderCellDef md-sort-header>EMAIL</md-header-cell>
        <md-cell *mdCellDef="let element"> {{element.candidateEmail}} </md-cell>
      </ng-container>

      <!-- examNameCode Column -->
      <ng-container mdColumnDef="examCodeName">
        <md-header-cell *mdHeaderCellDef md-sort-header>EXAM CODE:NAME</md-header-cell>
        <md-cell *mdCellDef="let element"> {{element.examCodeName}} </md-cell>
      </ng-container>

      <!-- locationName Column -->
      <ng-container mdColumnDef="locationName">
        <md-header-cell *mdHeaderCellDef md-sort-header>LOCATION NAME</md-header-cell>
        <md-cell *mdCellDef="let element"> {{element.locationName}} </md-cell>
      </ng-container>

      <!-- locationAddress Column -->
      <ng-container mdColumnDef="locationAddress">
        <md-header-cell *mdHeaderCellDef md-sort-header>LOCATION ADDRESS</md-header-cell>
        <md-cell *mdCellDef="let element"> {{element.locationAddress}} </md-cell>
      </ng-container>


    </md-table>
    <md-paginator #paginator [length]="conflictPaginationInfo.totalRecords" [pageIndex]="0" [pageSize]="dataSource.initialPageSize" [pageSizeOptions]="dataSource.pageSizeOptions">
    </md-paginator>
  </div>

  <!-- grid code end -->
</div>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-conflict-cases/adm-manage-conflict-cases.component.html